/** Max player name length shown in game UI (chat, panels, modals). */
export const PLAYER_NAME_DISPLAY_MAX = 15;

export function truncatePlayerName(name: string): string {
	if (name.length <= PLAYER_NAME_DISPLAY_MAX) {
		return name;
	}
	return `${name.slice(0, PLAYER_NAME_DISPLAY_MAX)}…`;
}
